
import styled from "styled-components";

export default function styleTab(Tabs){
    return styled(Tabs)`
        .date-range{
            text-align: center;
            margin-right: 90px;
        }
        .react-tabs__tab-panel{
            width: 83%;
        }
        .react-tabs__tab{
            border-radius: 0;
            padding: 15px 30px;
            width: 150px;
            font-size: 14px;
            cursor: pointer;
            font-weight: 500;
            list-style: none;
            display: inline;
        }
        .react-tabs__tab-list
        {
            border-bottom: none;
            padding: 10px;
        }
        .react-tabs__tab.react-tabs__tab--selected{
            background: rgba(235, 235, 235, 0.60);
        }
        }`;
}